import axios from 'axios';

export async function getPricing() {
  const {data} = await axios.get('/api/?entity=open&action=getPricing');
  return data && data.data;
}
